var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReleaseFullAlbum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7113 35.5512V39.4062H4.5084C2.3793 39.4062 0.65332 37.6803 0.65332 35.5512V4.71055C0.65332 2.58145 2.3793 0.855469 4.5084 0.855469H35.349C37.4781 0.855469 39.2041 2.58145 39.2041 4.71055V23.9859H35.349V4.71055H4.5084V35.5512H25.7113Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9287 10.7466V20.4016C19.3205 20.2253 18.6703 20.1308 18.0012 20.1308C14.9083 20.1308 12.2185 22.1482 12.2185 24.9497C12.2185 27.7512 14.9083 29.7685 18.0012 29.7685C21.094 29.7685 23.7838 27.7512 23.7838 24.9497V17.9499L26.5696 19.8071L28.7081 16.5995L19.9287 10.7466ZM19.9287 24.9497C19.9287 25.3418 19.1665 25.9135 18.0012 25.9135C16.8358 25.9135 16.0736 25.3418 16.0736 24.9497C16.0736 24.5576 16.8358 23.9859 18.0012 23.9859C19.1665 23.9859 19.9287 24.5576 19.9287 24.9497Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1461 4.71056L14.1461 0.855486L35.349 0.855487C37.4781 0.855488 39.2041 2.58146 39.2041 4.71056L39.2041 35.5512C39.2041 37.6803 37.4781 39.4062 35.349 39.4062L4.50842 39.4062C2.37931 39.4062 0.65334 37.6803 0.65334 35.5512L0.653341 16.2758L4.50842 16.2758L4.50842 35.5512L35.349 35.5512L35.349 4.71056L14.1461 4.71056Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseFullAlbum);
export default __webpack_public_path__ + "static/media/release-full-album.f3fae691.svg";
export { ForwardRef as ReactComponent };